import { type FC, useContext } from "react";

import { startCase } from "lodash";

import { Badge, Section } from "@alpacahq/ui/old";

import { AppDetailsContext } from "./AppDetailsPage";

export const AppDetailsCategories: FC = () => {
  const {
    client: {
      extension: { categories },
    },
  } = useContext(AppDetailsContext);

  return (
    <Section title="Categories">
      <div className="flex flex-wrap space-x-1.5">
        {(categories || []).filter(Boolean).map((category) => (
          <Badge variant="gray" key={category}>
            {startCase(category.replace(/_/g, " ").toLowerCase())}
          </Badge>
        ))}
      </div>
    </Section>
  );
};
